<template>
  <page-layout class="gallery_album">

    <div class="title">
      <div class="title_top">
        <p>Gallery</p>
      </div>
    </div>

    <article class="inner">

			<div class="gallery_sch">
        <h3><router-link to="/gallery">Gallery</router-link><em>&gt;</em><router-link :to="`/gallery/${getRouteParamsSeries}`">{{getSeriesTitle}}</router-link><em>&gt;</em><b>{{getAlbumTitle}}</b></h3>
				<div class="sch_box">
          <input type="text" placeholder="갤러리검색" v-model="keyword" @keyup.enter="search"><a class="sch_btn" href="javascript:" @click="search()" >검색</a>
          <a class="reset" @click="reset()">초기화</a>
				</div>
			</div>

    </article>

    <sub-page-layout no-border no-right-padding-top>

			<div class="list_gallery album_image_results">
				<ul>
					<li class="ctnr" @click="showModalAfterGetData(img)" v-for="img in getAlbumImages" :key="img.idx">
            <img v-if="isFileExist(img.album_img)" :src="img.album_img.url" class="fit_img"/>
					</li>
				</ul>
			</div>

		</sub-page-layout>


    <!-- PC Modal -->
    <q-dialog ref="modal" :no-route-dismiss="true" @hide="hideModal" v-if="!isMobile">
      <div class="gallery_pop">
        <div class="dark_bg" @click="$refs.modal.hide()"></div>
        <a class="close_btn" @click="$refs.modal.hide()"></a>
        <!-- prev/next button -->
        <div class="arrows" v-if="isModalInnerBox">
          <p class="next" @click="next()" v-if="selectedImage.key < getAlbumImageDataCnt-1"></p>
          <p class="prev" @click="prev()" v-if="selectedImage.key > 0"></p>
        </div>
        <div class="album_ctnr">
          <div class="img">
            <div class="img_wrap">
							<transition name="el-fade-in-linear">
                <div v-if="isModalInnerBox">
                  <img v-if="isFileExist(selectedImage.album_img)" :src="selectedImage.album_img.url">
                  <a class="download" :href="download"></a>
                </div>
              </transition>
						</div>
          </div>
          <div class="article">
            <transition name="el-fade-in-linear">
              <div v-if="isModalInnerBox">
                <p class="subj">{{ selectedImage.title }}</p>
                <p class="tag" v-if="selectedImage.tags">
                  <router-link :to="`/article/tag/${tag}`" v-for="(tag, i) in selectedImage.tags" :key="i">{{tag}}</router-link>
                </p>
                <p class="series">{{ selectedImage.series_title }}<em>&gt;</em>{{ selectedImage.album_title }}</p>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </q-dialog>

    <!-- Mobile Modal (원본) -->
<!--    <q-dialog ref="modal" :no-route-dismiss="true" @hide="hideModal" v-else>-->
<!--      <div class="gallery_pop">-->
<!--        <div class="dark_bg" @click="$refs.modal.hide()"></div>-->
<!--        <a class="close_btn" @click="$refs.modal.hide()"></a>-->
<!--        &lt;!&ndash; prev/next button &ndash;&gt;-->
<!--        <div class="arrows" v-if="isModalInnerBox">-->
<!--          <p class="next" @click="next()" v-if="selectedImage.key < getAlbumImageDataCnt-1"></p>-->
<!--          <p class="prev" @click="prev()" v-if="selectedImage.key > 0"></p>-->
<!--        </div>-->
<!--        <div class="album_ctnr">-->
<!--          <div class="img">-->
<!--            <div class="img_wrap">-->
<!--              <transition name="el-fade-in-linear">-->
<!--                <div v-if="isModalInnerBox">-->
<!--                  <img v-if="isFileExist(selectedImage.album_img) && isModalInnerBox" :src="selectedImage.album_img.url" />-->
<!--                  <a class="download" :href="download"></a>-->
<!--                </div>-->
<!--              </transition>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="article">-->
<!--            <transition name="el-fade-in-linear">-->
<!--              <div v-if="isModalInnerBox">-->
<!--                <p class="subj">{{ selectedImage.title }}</p>-->
<!--                <p class="tag" v-if="selectedImage.tags">-->
<!--                  <router-link :to="`/article/tag/${tag}`" v-for="(tag, i) in selectedImage.tags" :key="i">{{tag}}</router-link>-->
<!--                </p>-->
<!--                <p class="series">{{getSeriesTitle}}<em>&gt;</em>{{getAlbumTitle}}</p>-->
<!--              </div>-->
<!--            </transition>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </q-dialog>-->

    <!-- Mobile Modal -->
    <q-dialog ref="modal" :no-route-dismiss="true" @hide="hideModal" v-else>
      <div class="gallery_pop">
        <div class="dark_bg" @click="$refs.modal.hide()"></div>
        <a class="close_btn" @click="$refs.modal.hide()"></a>
        <div class="album_ctnr">
          <div class="img">
            <div class="img_wrap">
              <q-carousel v-model="slide"
                          transition-prev="slide-right"
                          transition-next="slide-left"
                          swipeable
                          animated
                          @input="changeSlide"
                          style="width: 100vw; height: auto;"
                          class="bg-transparent"
              >
                <q-carousel-slide :name="img.idx" v-for="img in getAlbumImages" :key="img.idx" class="column no-wrap flex-center">
                  <img :src="img.album_img.url" class="" />
                </q-carousel-slide>
              </q-carousel>
              <transition name="el-fade-in-linear">
                <a class="download" :href="download" v-if="isModalInnerBox"></a>
              </transition>
            </div>
          </div>
          <transition name="el-fade-in-linear">
            <div class="article" v-if="isModalInnerBox">
              <p class="subj">{{ selectedImage.title }}</p>
              <p class="tag" v-if="selectedImage.tags">
                <router-link :to="`/article/tag/${tag}`" v-for="(tag, i) in selectedImage.tags" :key="i">{{tag}}</router-link>
              </p>
              <p class="series">{{ selectedImage.series_title }}<em>&gt;</em>{{ selectedImage.album_title }}</p>
            </div>
          </transition>
        </div>
      </div>
    </q-dialog>

  </page-layout>
</template>

<script>
	import Vue from 'vue'
  import { QDialog, Loading, QCarousel, QCarouselSlide } from 'quasar'
  import { Image } from 'element-ui'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import PageLayout from '../layouts/PageLayout'
  import { mapGetters } from 'vuex'
  export default {
    name: "GallerySeriesAlbum",
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      QDialog,
      QCarousel,
      QCarouselSlide,
      Loading,
      [Image.name]: Image,
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | ${this.getAlbumImageTitle}`,
        titleTemplate: '%s',
        meta: this.getSeoMeta
      }
    },
    data () {
      return {
        isModalInnerBox: true,
        selectedImage: {},
        keyword: '',
        slide: 0
      }
    },
    activated () {
      this.$store.dispatch('callSeries').then(() => {
        const index = this.getSeries.findIndex(row => row.parameter === this.getRouteParamsSeries)
        if (index < 0) this.$router.replace('/gallery')
      })
      this.$store.dispatch('callAlbums').then(() => {
        const index = this.getAlbums.findIndex(row => row.parameter === this.getRouteParamsAlbum)
        if (index < 0) this.$router.replace('/gallery/' + this.getRouteParamsSeries)
        else {
          // view_cnt 업데이트
          this.$axios.put('/albums/view_cnt/' + this.getAlbums[index].idx)
        }
      })
      this.$store.dispatch('loadAlbumImages', {album_parameter: this.getRouteParamsAlbum})
    },
    deactivated() {
      this.$refs.modal.hide()
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getSeries',
        'getAlbums',
        'getAlbumImages',
        'isExistAlbumImageData'
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
      getRouteParamsSeries () {
        return this.$route.params.series
      },
      getSeriesInfo () {
        return this.getSeries.find(row => row.parameter === this.getRouteParamsSeries)
      },
      getSeriesTitle () {
        return this.getSeriesInfo ? this.getSeriesInfo.title : ''
      },
      getRouteParamsAlbum () {
        return this.$route.params.album
      },
      getAlbumInfo () {
        return this.getAlbums.find(row => row.parameter === this.getRouteParamsAlbum)
      },
      getAlbumTitle () {
        return this.getAlbumInfo ? this.getAlbumInfo.title : ''
      },
      getAlbumImageDataCnt () {
        return this.getAlbumImages.length
      },
			getAlbumImageTitle () {
        return this.isExistAlbumImageData && this.selectedImage && this.selectedImage.title ? this.selectedImage.title : '라이브 토너먼트 현장 사진 갤러리'
      },
      download () {
        return Vue.prototype.$apiURL + '/album_images/download/' + this.selectedImage.idx
      }
    },
		methods: {
      ...CommonMethods,
      showModalAfterGetData (row) {
        // Loading.show()
        this.isModalInnerBox = false
        this.selectedImage = this.cloneData(row)
        this.slide = this.selectedImage.idx
        this.showModal()
        setTimeout(() => {
          // Loading.hide()
          this.isModalInnerBox = true
        }, 200)
      },
      showModal () {
        this.$refs.modal.show()
      },
      hideModal () {
        this.selectedImage = {}
      },
      search () {
        this.$router.replace('/gallery/search/' + this.keyword)
        this.keyword = ''
      },
      reset () {
        this.$router.replace('/gallery')
        this.keyword = ''
      },
      next () {
        this.isModalInnerBox = false
        this.selectedImage = this.cloneData(this.getAlbumImages.find(row => row.key === this.selectedImage.key + 1))
        this.slide = this.selectedImage.idx
        setTimeout(() => { this.isModalInnerBox = true}, 200)
      },
      prev () {
        this.isModalInnerBox = false
        this.selectedImage = this.cloneData(this.getAlbumImages.find(row => row.key === this.selectedImage.key - 1))
        this.slide = this.selectedImage.idx
        setTimeout(() => { this.isModalInnerBox = true}, 200)
      },
      changeSlide (idx) {
        this.isModalInnerBox = false
        const row = this.getAlbumImages.find(row => row.idx === idx)
        this.selectedImage = this.cloneData(row)
        setTimeout(() => {
          this.isModalInnerBox = true
        }, 200)
      },
      show (img) {
        const $this = this
        const $viewer = this.$viewerApi({
          images: [img.album_img.url],
          options: {
            show(event) {
              $this.isModalInnerBox = false
            },
            hide(event) {
              $this.isModalInnerBox = true
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  .gallery_album {
    position: relative;
    top: -40px;
  }
  .gallery_album .title {
    background: url(/statics/img/bg_sub_title.jpg) center no-repeat;
    background-size: cover;
    margin-bottom: 40px;
  }
  .title_top {
    position: relative;
    width: 1220px;
    height: 180px;
    display: flex;
    align-items: center;
    margin: 0 auto;
  }
  .title_top:before {
    content: "";
    display: inline-block;
    width: 54px;
    height: 54px;
    background: url(/statics/img/bi_white.png) center no-repeat;
    background-size: cover;
    margin-right: 15px;
  }
  .title_top p {
    font-family: 'Roboto Slab';
    font-size: 60px;
    font-weight: 900;
    color: #fff;
    line-height: 1.0em;
    text-transform: capitalize;
    z-index: 1;
  }
  .gallery_sch {
    position: relative;
		margin: 0 0 20px 0;
  }
	.gallery_sch h3 {
		font-size: 30px;
		font-weight: 500;
		letter-spacing: -0.03em;
    width: 800px;
  }
	.gallery_sch h3 b {
		font-weight: 900;
  }
	.gallery_sch h3 em {
		font-size: 18px;
		font-weight: 600;
		color: #888;
    font-style: normal;
		padding: 0 15px;
  }
	.gallery_sch h3 a {
		color: #008c03;
  }
	.gallery_sch h3 a:hover {
		text-decoration: underline;
  }
  .gallery_sch .sch_box {
		display: inline-block;
    width: 365px;
    height: 40px;
		background: #f5f5f5;
    position: absolute;
    top: 0;
    right: 0;
  }
  .gallery_sch .sch_box input {
    width: 208px;
    height: 40px;
    padding: 0 12px;
    font-size: 18px;
    font-weight: 600;
    color: #008c03;
    border: 1px solid #000;
  }
  .gallery_sch .sch_box input:disabled {
    background: #222 !important;
  }
  .gallery_sch .sch_box input::-webkit-input-placeholder {
    color: #bbb;
    font-weight: 500;
  }
  .gallery_sch .sch_box input:-moz-placeholder {
    color: #bbb;
  }
  .gallery_sch .sch_box input::-moz-placeholder {
    color: #bbb;
  }
  .gallery_sch .sch_box input:-ms-input-placeholder {
    color: #bbb;
  }
	.gallery_sch .sch_btn {
    display: inline-block;
    width: 80px;
    height: 40px;
    transition: all 0.2s;
		background: #000;
		font-size: 18px;
		font-weight: 600;
		color: #fff;
		padding: 8px 0;
		text-align: center;
  }
	.gallery_sch .reset {
    display: inline-block;
    width: 70px;
    height: 40px;
    transition: all 0.2s;
		font-size: 16px;
		font-weight: 500;
		color: #000;
		padding: 9px 0;
		text-align: center;
		border: 1px solid #999;
		margin-left: 5px;
  }
  /*.list_gallery li {
    position: relative;
    display: inline-block;
    margin: 0 10px 10px 0;
    width: calc((100% - 20px) / 3);
    height: 280px;
    cursor: pointer;
  }
  .list_gallery li:nth-child(3n) {
    margin-right: 0;
  }*/
  .list_gallery ul {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-gap: 4px;
    grid-auto-rows: minmax(200px, auto);
    grid-auto-flow: dense;
    padding: 0;
  }
  .list_gallery li {
    position: relative;
    cursor: pointer;
  }
  .list_gallery li:nth-child(3n+1),
  .list_gallery li:nth-child(4n+1) {
    grid-column-end: span 2;
    grid-row-end: span 2;
  }
  .list_gallery li img {
    width: 100%;
    transition: .15s;
  }
  .list_gallery li:hover img {
    filter: brightness(120%);
  }
  .list_gallery li .subj {
    position: absolute;
		bottom: 0;
		display: block;
		width: 100%;
		background: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,1.0) 80%);
		color: #fff;
		padding: 40px 30px 20px 30px;
		box-sizing: border-box;
  }
  .list_gallery li .subj h5 {
		font-size: 22px;
    font-weight: 700;
  }
  .list_gallery li .subj h6 {
		font-size: 15px;
    font-weight: 300;
		color: #00ff64;
  }
  .list_gallery li .subj h6 b {
		font-weight: 900;
  }
  .gallery_pop {
    max-width: unset;
    height: auto;
    max-height: unset;
		overflow: visible;
  }
  .gallery_pop .dark_bg {
    position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0,0,0,0.5);
  }
  .gallery_pop .close_btn {
		position: absolute;
		top: 15px;
		right: 15px;
		cursor: pointer;
		width: 40px;
		height: 40px;
		z-index: 1;
	}
	.gallery_pop .close_btn:before {
		content: "×";
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-48%, -54%);
		font-size: 40px;
		font-weight: 300;
		color: #00ff64;
	}
	.gallery_pop .close_btn:hover:before {
		color: #fff;
	}
  .gallery_pop .album_ctnr {
    width: 100%;
    height: 100%;
		text-align: center;
  }
  .gallery_pop .album_ctnr .img {
    align-items: center;
    position: relative;
  }
  .gallery_pop .album_ctnr .img .img_wrap {
    display: inline-block;
  }
  .gallery_pop .album_ctnr .img .img_wrap .download {
		position: absolute;
		bottom: 0;
		margin-left: 20px;
		display: inline-block;
		width: 50px;
		height: 50px;
		border-radius: 5.0em;
		border: 1px solid rgba(255,255,255,0.35);
		background-image: url('/statics/img/icon_download.png');
		background-size: 45%;
		background-repeat: no-repeat;
		background-position: 50% 48%;
		cursor: pointer;
  }
  .gallery_pop .album_ctnr .img .img_wrap .download:hover {
		border: 1px solid rgba(255,255,255,0.75);
  }
  .gallery_pop .album_ctnr .img img {
    max-width: 82vw;
    max-height: 82vh;
  }
  .gallery_pop .album_ctnr .article {
    position: relative;
    padding: 10px;
    word-break: normal;
		color: #fff;
  }
  .gallery_pop .album_ctnr .article .subj {
    font-size: 1.6em;
    font-weight: 700;
    letter-spacing: -0.02em;
		padding: 5px 0;
  }
  .gallery_pop .album_ctnr .article .tag a {
    display: inline-block;
    margin-right: 10px;
    line-height: 1.6em;
    font-size: 1.1em;
    font-weight: 300;
    color: #00ff64;
  }
  .gallery_pop .album_ctnr .article .tag a:before {
    content: "#";
  }
  .gallery_pop .album_ctnr .article .tag a:hover {
    color: #fff;
  }
  .gallery_pop .album_ctnr .article .series {
    color: rgba(255,255,255,0.75);
		line-height: 1.0em;
		padding-top: 5px;
  }
  .gallery_pop .album_ctnr .article .series em {
		font-style: normal;
		font-size: 0.6em;
    color: rgba(255,255,255,0.5);
		padding: 0 10px;
  }
  .gallery_pop .arrows {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 96vw;
    height: 50px;
    transform: translate(-50%, -50%);
		z-index: 99;
  }
  .gallery_pop .arrows p {
    display: inline-block;
    width: 50px;
    height: 50px;
    background: rgba(0,0,0,0.5);
    border-radius: 100%;
    position: relative;
    cursor: pointer;
  }
  .gallery_pop .arrows p:before {
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    border: #fff solid;
    border-width: 2px 2px 0 0;
    position: absolute;
    top: 50%;
    left: 44%;
    transform: translate(-50%, -50%) rotate(45deg);
  }
  .gallery_pop .arrows p.prev:before {
    border-width: 0 0 2px 2px;
    left: 56%;
  }
  .gallery_pop .arrows p.next {
    float: right;
  }
  .gallery_pop .arrows p:hover {
    background: rgba(0,0,0,0.8);
  }
  /*.gallery_pop .download {
    position: absolute;
    right: 2%;
		bottom: 4%;
		display: inline-block;
		font-size: 11px;
		font-weight: 900;
		color: #fff;
		text-transform: uppercase;
		background: rgba(255,255,255,0.0);
		padding: 10px 20px;
		border-radius: 5.0em;
		border: 1px solid rgba(255,255,255,0.5);
		line-height: 1.7em;
  }*/
  /deep/ .fr-video { display: block !important; position: relative !important; height: 0 !important; padding-bottom: 56.25% !important; }
  /deep/ .fr-video iframe { position: absolute !important; width: 100% !important; height: 100% !important; top:0; left: 0; }
  /deep/ [data-f-id="pbf"] {
    display: none;
  }
	.q-dialog__inner > div {
		box-shadow: none;
	}
</style>
